

  
  <div class="mt-4 mb-8" *ngIf="announcements.length > 0">
    <div class="max-w-3xl mx-auto">
        <h2 class="text-sm font-semibold text-gray-500 dark:text-gray-400 uppercase tracking-wider mb-4 text-center">Announcements</h2>

        <!-- Listing of announcements -->
        <div class="shake relative bg-white dark:bg-gray-900 shadow-md p-5 mb-4 rounded-xl border-l-4 border-primary-600 dark:border-primary-500 transition-all hover:shadow-lg" *ngFor="let announcement of announcements">
          <div class="flex items-start gap-5">
            <div class="w-12 h-12 rounded-full bg-primary-100 dark:bg-primary-900/40 flex items-center justify-center flex-shrink-0">
                <mat-icon class="text-primary-600 dark:text-primary-400 w-6 h-6" [svgIcon]="'tabler_outline:bell-ringing'"></mat-icon>
            </div>
            
            <div class="flex-grow pr-8">
              <h3 class="text-lg font-bold text-gray-900 dark:text-white mb-1" [innerHTML]="announcement.title"></h3>
              <div class="text-sm text-gray-600 dark:text-gray-400 leading-relaxed" [innerHTML]="announcement.description">
              </div>
              <button mat-icon-button (click)="read(announcement.id)"  class="absolute top-3 right-3 text-gray-400 hover:text-red-500 transition-colors">
                  <mat-icon [svgIcon]="'tabler_outline:x'" class="icon-size-5"></mat-icon>
              </button>
            </div>
          </div>
        </div>
    </div>
</div>


